import React from 'react';

const TranslatedText = ({ translateKey, value }) => (
    <span data-translate-key={translateKey}>
    {value}
  </span>
);

const translateWithComponent = (translate) => {
    const result = (key, templateParameters) => {
        const value = translate(key, templateParameters);
        const _render = () => (
            <TranslatedText
                value={value}
                translateKey={key}
            />
        );

        return { ..._render(), toString: () => (value) };
    };

    Object.keys(translate).forEach((key) => {
        result[key] = translate[key];
    });

    return result;
};

export default translateWithComponent;



// WEBPACK FOOTER //
// ./src/helpers/LanguageModel/translateWithComponent.js